import type { FC } from 'react';
import React, { useCallback } from 'react';

import { RangeSlider } from 'Components/shared/RangeSlider';
import type { Filter } from 'Types/filter';

import { getFilterNumericValue } from '../../FilterBarV2.helpers';

import type { RangeFilterConfig } from './AllFiltersContent.consts';
import { getRangeLabel } from './AllFiltersContent.helpers';

import styles from './AllFiltersContent.module.scss';

interface RangeSectionProps {
	config: RangeFilterConfig;
	filters: Filter;
	onChange: (from: Nullable<number>, to: Nullable<number>) => void;
}

export const RangeSection: FC<RangeSectionProps> = ({ config, filters, onChange }) => {
	const fromValue = config.fromId ? getFilterNumericValue({ filters, key: config.fromId }) : null;
	const toValue = config.toId ? getFilterNumericValue({ filters, key: config.toId }) : null;

	const handleChange = useCallback(
		(from: number, to: number) => {
			onChange(from === config.min ? null : from, to === config.max ? null : to);
		},
		[config.max, config.min, onChange],
	);

	return (
		<div className={styles.rangeSliderSection}>
			<RangeSlider
				className={styles.rangeSlider}
				from={fromValue ?? config.min}
				max={config.max}
				min={config.min}
				onChange={handleChange}
				step={config.increment}
				to={toValue ?? config.max}
			/>
			<span className={styles.rangeLabel}>{getRangeLabel(config, filters)}</span>
		</div>
	);
};
